<template>
  <div class="contain">
    <div ref="temp" />
    <div ref="waveSpectrogram" style="width: 100%; height: 210px" />
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import CursorPlugin from "wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js";
import RegionsPlugin from "wavesurfer.js/dist/plugin/wavesurfer.regions";
import ColorMap from "colormap";
import Spectrogram from "wavesurfer.js/dist/plugin/wavesurfer.spectrogram.js";

export default {
  data() {
    return {
      waveSurfer: null,
      height: 210
    };
  },
  mounted() {
  },
  methods: {
    initPlayer() {
      this.waveSurfer = WaveSurfer.create({
        container: this.$refs.temp,
        waveColor: "rgb(70,182,195)",
        progressColor: "rgb(70,182,195)",
        cursorColor: "#ffff00",
        backgroundColor: "black",
        // backgroundColor: "rgb(52 52 52 / 100%)",
        height: 0,
        plugins: [
          CursorPlugin.create({
            showTime: true,
            opacity: 1,
            customShowTimeStyle: {
              "background-color": "#000",
              color: "#fff",
              padding: "2px",
              "font-size": "8px",
            },
          }),
          RegionsPlugin.create({}),

          Spectrogram.create({
            wavesurfer: this.waveSurfer,
            container: this.$refs.waveSpectrogram,
            labels: false,
            height: this.height,
            labels: true,
            fftSamples: 512,
            frequencyMax: 4000,
            colorMap: ColorMap({
              colormap: "summer",
              nshades: 256,
              format: "float",
            }),
          }),
        ],
      });
      this.waveSurfer.on("ready", () => {
        this.waveSurfer.pause();
      });
      this.waveSurfer.on("play", () => {
        this.$emit("status-changed", "playing");
      });
      this.waveSurfer.on("pause", () => {
        this.$emit("status-changed", "pause");
      });
    },
  },
};
</script>

<style scoped>
.contain{
  background-color: var(--audio-bg);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/realTime/spectrogram-player.vue